const styles = (theme) => ({
    documentsContainer: {
        marginTop: '20px',
    },
    documentsItens: {
        display: 'flex',
        alignItems: 'flex-end',
    },
    stickMessage: {
        position: 'relative',
        right: '0px',
        [theme.breakpoints.up('md')]: {
            position: 'absolute',
            right: '-30px',
            top: '-20px',
            width: '100%',
        },
    },
    stickMessageContainer: {
        order: -1,
        display: 'block',
        position: 'relative',
        [theme.breakpoints.up('md')]: {
            order: 1,
            // right: '-40px',
        },
    },
    centerProgress: {
        textAlign: 'center',
    },
    divider: {
        marginTop: '30px',
    },
    title: {
        fontWeight: '500',
    },
});

export default styles;
